import React from 'react'
import AdminPage from '../../admin/shared/AdminPage'
import DelegatedIdentityList from './DelegatedIdentityList'

function DelegatedIdentityManagement () {
  return (
    <AdminPage>
      <DelegatedIdentityList />
    </AdminPage>
  )
}

export default DelegatedIdentityManagement
